var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0833 2.3335H2.91663C2.4525 2.3335 2.00738 2.51787 1.67919 2.84606C1.351 3.17425 1.16663 3.61937 1.16663 4.0835V9.91683C1.16663 10.381 1.351 10.8261 1.67919 11.1543C2.00738 11.4825 2.4525 11.6668 2.91663 11.6668H11.0833C11.5474 11.6668 11.9925 11.4825 12.3207 11.1543C12.6489 10.8261 12.8333 10.381 12.8333 9.91683V4.0835C12.8333 3.61937 12.6489 3.17425 12.3207 2.84606C11.9925 2.51787 11.5474 2.3335 11.0833 2.3335ZM10.6925 3.50016L6.99996 6.271L3.30746 3.50016H10.6925ZM11.0833 10.5002H2.91663C2.76192 10.5002 2.61354 10.4387 2.50415 10.3293C2.39475 10.2199 2.33329 10.0715 2.33329 9.91683V4.22933L6.64996 7.46683C6.75093 7.54256 6.87374 7.5835 6.99996 7.5835C7.12618 7.5835 7.24899 7.54256 7.34996 7.46683L11.6666 4.22933V9.91683C11.6666 10.0715 11.6052 10.2199 11.4958 10.3293C11.3864 10.4387 11.238 10.5002 11.0833 10.5002Z",
    fill: "#5C5C5C",
    fillOpacity: 0.75
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.02e20e85.svg";
export { ForwardRef as ReactComponent };